const SAE_EMAIL = 'sae.es@bbva.com';

class RequestFormSicknessPanelController {

  constructor() {
    this.SAE_EMAIL = SAE_EMAIL;
  }
}

export default RequestFormSicknessPanelController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/requestForm/requestFormSicknessPanel/requestFormSicknessPanel.controller.js